import moment from "moment"

import {
    DASHBOARD_INFO_RESPONSE,
    UNAUTHENTICATED,
} from "../../actions/action-types"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case DASHBOARD_INFO_RESPONSE:
            const { coverage, flow, ...simpleMetrics } = data
            let flowData = Object.keys(flow)
                .filter((key) => key !== "0")
                .map((key) => ({
                    timestamp: parseInt(key, 10),
                    count: flow[key],
                }))
            flowData.sort((flow1, flow2) => flow2.timestamp - flow1.timestamp)
            flowData = flowData.map((flowItem) => ({
                key: moment.unix(flowItem.timestamp).local().format("DD/MM"),
                count: flowItem.count,
            }))
            return {
                ...state,
                data: {
                    coverage: coverage.map(({ topic, topic_id, count }) => ({
                        topic: topic || "(No name)",
                        topic_id,
                        count,
                    })),
                    flow: flowData,
                    simpleMetrics,
                },
                lastUpdatedAt: receivedAt,
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
